import { render, staticRenderFns } from "./panel-navigation.vue?vue&type=template&id=21e79dd9&scoped=true"
import script from "./panel-navigation.vue?vue&type=script&lang=js"
export * from "./panel-navigation.vue?vue&type=script&lang=js"
import style0 from "./panel-navigation.vue?vue&type=style&index=0&id=21e79dd9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e79dd9",
  null
  
)

export default component.exports